import { render, staticRenderFns } from "./rCheckbox.vue?vue&type=template&id=f607e9b0&"
import script from "./rCheckbox.vue?vue&type=script&lang=js&"
export * from "./rCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./rCheckbox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports